<template>
  <div class="pagecontent">
    <!-- 麵包屑 -->
    <el-row>
      <el-col :span="24">
        <div style="height: 30px;margin-top: 20px;padding-left: 16px">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首頁</el-breadcrumb-item>
            <el-breadcrumb-item class="breadTitleColor" :to="{ path: '/lectureroom' }">影音報恩講堂</el-breadcrumb-item>
            <el-breadcrumb-item class="breadTitleColor">{{breadTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 内容 -->
    <el-row>
      <!-- 左邊内容 一個小圖片  一個下拉目錄樹 -->
      <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
        <div class="left-content">
          <el-image :src="leftImage" fit="contain"></el-image>
          <div class="item">
            <div class="title-box">
            </div>
            <div class="content">
              <span class="up">報恩講堂</span>
              <span class="down">Dharma Talks</span>
            </div>
          </div>
          <el-tree class="tree" style="font-size: 1.8rem" v-loading="baoenTree.code ==1"
                   :highlight-current="true"
                   :data="baoenTree.categories"
                   :props="myTreeProps"
                   @node-click="handleNodeClick">
          </el-tree>
        </div>
      </el-col>
      <!-- 右邊内容 四次大經科注 最近更新内容  搜索内容 -->
      <el-col :xs="24" :sm="24" :md={push:1,span:19} :lg={push:1,span:19} :xl={push:1,span:19}>
        <!-- 四次大經科注 -->
        <el-row v-if="topspeechShow">
          <el-col>
            <div v-loading="baoenTree.code ==1 " class="title-div">{{topspeech.name}}</div>
          </el-col>
        </el-row>
        <el-row v-if="topspeechShow">
          <el-col :span="24">
            <div class="topspeechList">
              <el-row>
                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" v-for="item in topspeech.data" :key="item.id"
                        data-item="item">
                  <card :cardInfo="item" :url="topurl" :preUrl="preUrl"></card>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <!-- 最近更新内容 -->
        <el-row>
          <el-col>
            <div class="update-div"><span v-if="topspeechShow">最近更新:</span><span v-else>{{baoenTree.category === undefined?'' :baoenTree.category.AMTB_NAME}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="topspeechShow">
          <el-col :span="24">
            <el-table class="right-table" row-class-name="rowstyle" v-loading="baoenTree.code ==1 "
                      :data="recentspeech"
                      @row-click="rowClickLatestUpdates" >
              <el-table-column width="250" fixed label="講題"
                               prop="title">
              </el-table-column>
              <el-table-column width="100" label="集數"
                               prop="numdesc">
              </el-table-column>
              <el-table-column label="編號"
                prop="itemid" width="150">
              </el-table-column>
              <el-table-column label="地點" :show-overflow-tooltip="true"
                prop="speechplace" width="150">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <!--熱門影音-->
        <el-row>
          <el-col>
            <div class="update-div"><span v-if="topspeechShow">熱門影音:</span><span v-else>{{baoenTree.category === undefined?'' :baoenTree.category.AMTB_NAME}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="topspeechShow">
          <el-col :span="24">
            <el-table class="right-table" row-class-name="rowstyle" v-loading="baoenTree.code ==1 "
                      :data="hotspeech"
                      @row-click="hotRowClickLatestUpdates" >
              <el-table-column width="250" fixed label="講題"
                               prop="title">
              </el-table-column>
              <el-table-column width="100" label="集數"
                               prop="numbers">
              </el-table-column>
              <el-table-column label="編號"
                               prop="menuid" width="150">
              </el-table-column>
              <el-table-column label="地點" :show-overflow-tooltip="true"
                               prop="speechplace" width="150">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col>
            <el-radio v-model="selectRadio" label="1">列表式</el-radio>
            <el-radio v-model="selectRadio" label="2">棋盤式</el-radio>
          </el-col>
          <el-col :span="24" v-if="selectRadio == 1">
            <el-table class="right-table" v-loading="baoenloading"
                      :data="baoenCategoryList.data" @sort-change="clickSort"
                      @row-click="rowClick" row-class-name="rowstyle">
              <el-table-column width="150"  fixed label="講題"
                               prop="titlealt" sortable="custom" >
              </el-table-column>
              <el-table-column label="日期" sortable="custom"
                prop="speechdate" width="150">
              </el-table-column>
              <el-table-column label="總集數" sortable="custom"
                               prop="numbers" width="100">
              </el-table-column>
              <el-table-column label="地點" :show-overflow-tooltip="true"
                               prop="speechplace" sortable="custom" width="150">
              </el-table-column>
              <el-table-column width="100" label="編號" sortable="custom"
                               prop="menuid" >
              </el-table-column>
              <el-table-column label="音頻"
                               prop="mp3" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.mp3 ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="視頻"
                               prop="mp4" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.mp4 ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="高清視頻"
                               prop="himp4" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.himp4 ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="文字"
                               prop="txt" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.txt ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" v-if="selectRadio == 2"
                  :xs="24" :sm="24" :md="6" :lg="6" :xl="6" v-for="item in baoenCategoryList.data" :key="item.id"
                  data-item="item">
            <playcard ref="playcard" :cardInfo="item" :url="topurl" :preUrl="preUrl" @playcardClick="playcardClick"></playcard>
          </el-col>
        </el-row>
        <el-row v-if="!topspeechShow"><br></el-row>
        <el-row v-if="!topspeechShow"><br></el-row>
        <el-row v-if="!topspeechShow"><br></el-row>
        <el-row v-if="!topspeechShow"><br></el-row>
        <el-row v-if="!topspeechShow">
          <el-col :span="24">
            <el-pagination
              :layout="layoutStyle"
              :page-size="20"
              :pager-count="pageCount"
              background
              small
              :current-page.sync="currentPage"
              @current-change="pagechange"
              @prev-click="preclick"
              @next-click="nextclick"
              :total="baoenCategoryList.total-0">
            </el-pagination>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="search-div">
              <el-row style="margin-top: 20px;">
                <el-col :span="24">
                  <span style="font-size: 17px;font-weight: bold;">搜尋講演關鍵字:</span>
                </el-col>
              </el-row>
              <el-row style="margin-top: 20px;">
                <el-col :span="24">
                  <!--<el-input id="searchInputId" placeholder="請輸入關鍵字" @change="searchBlur" size="small" maxlength="20" v-model="input">
                    <el-button slot="append" icon="el-icon-search" @click="queryList">搜尋</el-button>
                  </el-input>-->
                  <memoryrecent id="searchInputId" ref="parentMemoryRencentRef" :placeholderkeyword="placeholderkeyword" @search-mbBlur="searchBlur" @search-mbBtn="queryList">
                  </memoryrecent>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row v-loading="queryloading" v-if="clickQuery">
          <el-col :span="24">
            <span style="font-size: 17px;font-weight: bold;">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp搜尋結果：</span>
            <!--<h3>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp搜尋結果：</h3>-->
            <el-table class="right-table" :stripe=true @sort-change="clickSortQuery"
                      :data="baoenQueryList" @row-click="queryrowClick" row-class-name="rowstyle">
              <el-table-column width="120" fixed  label="講題" sortable="custom"
                               prop="titlealt">
              </el-table-column>
              <el-table-column width="150" label="日期" sortable="custom"
                               prop="speechdate">
              </el-table-column>
              <el-table-column label="總集數" sortable="custom"
                               prop="numbers" width="100">
              </el-table-column>
              <el-table-column width="150" label="地點" sortable="custom" :show-overflow-tooltip="true"
                               prop="speechplace">
              </el-table-column>
              <el-table-column width="100" label="編號" sortable="custom"
                               prop="menuid">
              </el-table-column>
              <el-table-column label="音頻"
                               prop="mp3" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.mp3 ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="視頻"
                               prop="mp4" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.mp4 ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="高清視頻"
                               prop="himp4" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.himp4 ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="文字"
                               prop="txt" width="100">
                <template slot-scope="scope">
                  <el-tag
                    type='primary'
                    disable-transitions>{{scope.row.txt ==1 ? '有':'無'}}</el-tag>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row v-if="clickQuery">
          <el-col :span="24">
            <el-pagination
              :layout="layoutStyle"
              :page-size="20"
              :pager-count="pageCount"
              background
              small
              :current-page.sync="currentPageSearch"
              @current-change="pagechangeSearch"
              @prev-click="preclickSearch"
              @next-click="nextclickSearch"
              :total="baoenQueryListSize">
            </el-pagination>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="search-div">
              <el-row style="margin-top: 20px;">
                <el-col :span="24">
                  <span style="width: 45rem;padding-bottom: 2rem" v-html="ftpstatement">搜尋講演關鍵字:</span>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {mapMutations, mapState} from 'vuex'
  import card from '/components/playcard2'
  import playcard from '/components/playcard4'
  import memoryrecent from '/components/memoryrecent'

  export default {
    name: 'lectureroom',
    data () {
      return {
        page: 1,
        categoryid: 1,
        clickQuery: false,
        currentPage: 1,
        currentPageSearch: 1,
        pageCount: 5,
        layoutStyle: 'total, prev, pager, next',
        myTreeProps: {
          label: 'AMTB_NAME',
          children: 'categories',
          isLeaf: true
        },
        topurl: 'videoplay',
        input: '',
        parentid: 0,
        leftImage: '/static/images/unesco_mjk.jpg',
        activeName: '1',
        cardObject1: {
          id: 1,
          url: 'videoplay',
          src: '/static/images/aboutmasterchinkung.JPG',
          infoCh: '净土大经解演义',
          infoEn: ''
        },
        selectRadio: '2',
        breadTitle: '',
        cardObject2: {id: 2, src: '/static/images/collectionebook.JPG', infoCh: '净土大经科注', infoEn: ''},
        cardObject3: {id: 3, src: '/static/images/essenceoftalk.JPG', infoCh: '2012净土大经科注', infoEn: ''},
        myhtml: '<span style="font-size: 17px;font-weight: bold;">從FTP站台下載影音檔案:</span><br/>' +
          '建議用<a href="https://filezilla-project.org/download.php?type=client" target="_blank">filezilla</a>軟件下載，不需帳號密碼。請記下影音編號，再選擇離自己最近的主機，選擇MP3音頻、MP4視頻目錄，再依編號找到相應目錄下的檔案下載。\n' +
          '<br/>' +
          '台灣 ftp://ftp1.amtb.tw/\n' +
          '<br/>' +
          '德國 ftp://ftp.amtb.de/\n' +
          '<br/>' +
          '大陸 ftp://61.160.251.35/\n' +
          '<br/><br/>' +
          '【聲明啟事】<br/>' +
          '淨空老法師所有一切講演著述，暨四眾同修打字、校對、整理，公開授權大眾流通及下載閱讀。不得擅自加註版權所有，任意增減內容，非法牟利，侵害公眾權益及原著本意。<br/>',
        placeholderkeyword: '請輸入關鍵字'

      }
    },
    methods: {
      ...mapMutations([
        'INIT_BAOEN_TREE', 'GET_BAOEN_LIST', 'QUERY_BAOEN_LIST', 'QUERY_BAOEN_ALL_LIST', 'DES_BAOEN_TREE'
      ]),
      searchBlur (e) {
        this.input = e
        this.clickQuery = true
        let paramm = []
        paramm.push(this.input)
        this.currentPageSearch = 1
        this.QUERY_BAOEN_ALL_LIST({paramer: paramm, page: 1, pagenum: 20, column: 'menuid', type: 'desc'})
      },
      pagechange (val) {
        let paramer = []
        paramer.push(this.parentid)
        this.GET_BAOEN_LIST({paramer: paramer, page: val, pagenum: 20, column: 'menuid', type: 'desc'})
        this.page = val
        window.scrollTo(0, 400)
      },
      preclick (val) {
        let paramer = []
        paramer.push(this.parentid)
        this.GET_BAOEN_LIST({paramer: paramer, page: val, pagenum: 20, column: 'menuid', type: 'desc'})
        this.page = val
        window.scrollTo(0, 400)
      },
      nextclick (val) {
        let paramer = []
        paramer.push(this.parentid)
        this.GET_BAOEN_LIST({paramer: paramer, page: val, pagenum: 20, column: 'menuid', type: 'desc'})
        this.page = val
        window.scrollTo(0, 400)
      },

      pagechangeSearch (val) {
        let paramer = []
        paramer.push(this.input)
        this.QUERY_BAOEN_ALL_LIST({paramer: paramer, page: val, pagenum: 20, column: 'menuid', type: 'desc'})
        this.page = val
        window.scrollTo(0, 1050)
      },
      preclickSearch (val) {
        let paramer = []
        paramer.push(this.input)
        this.QUERY_BAOEN_ALL_LIST({paramer: paramer, page: val, pagenum: 20, column: 'menuid', type: 'desc'})
        this.page = val
        window.scrollTo(0, 1050)
      },
      nextclickSearch (val) {
        let paramer = []
        paramer.push(this.input)
        this.QUERY_BAOEN_ALL_LIST({paramer: paramer, page: val, pagenum: 20, column: 'menuid', type: 'desc'})
        this.page = val
        window.scrollTo(0, 1050)
      },

      clickSort (a) {
        console.log('sort:%o', a)
        let order = 'desc'
        let sortType = a.prop
        if (a.order === 'descending') {
          order = 'desc'
        } else {
          order = 'asc'
        }
        let paramer = []
        paramer.push(this.parentid)
        this.GET_BAOEN_LIST({paramer: paramer, page: this.page, pagenum: 20, column: sortType, type: order})
      },
      clickSortQuery (a) {
        console.log('sort:%o', a)
        let order = 'desc'
        let sortType = a.prop
        if (a.order === 'descending') {
          order = 'desc'
        } else {
          order = 'asc'
        }
        let paramer = []
        paramer.push(this.input)
        this.QUERY_BAOEN_ALL_LIST({paramer: paramer, page: 1, pagenum: 20, column: sortType, type: order})
      },
      // 點擊左邊目錄樹，觸發的事件
      handleNodeClick (data) {
        this.breadTitle = data.AMTB_NAME
        // console.log(data)
        if (!Array.isArray(data.categories)) {
          let paramer = []
          paramer.push(data.AMTB_ID)
          this.parentid = data.AMTB_ID
          this.GET_BAOEN_LIST({paramer: paramer, page: 1, pagenum: 20, column: 'menuid', type: 'desc'})
          // window.location.href = this.currentUrl
          let THE_PATH = window.location.protocol + '//' + window.location.hostname + '/#/lectureroom?categoryid=' + data.AMTB_ID
          window.location.href = THE_PATH
          window.scrollTo(0, 0)
          this.clickQuery = false
          this.$refs.parentMemoryRencentRef.clearSearchInput()
        }
      },
      // 最新更新内容，點擊某一條觸發事件
      rowClickLatestUpdates (row, column, event) {
        if (this.topspeechShow) {
          let paramer = {
            menuidparent: row.itemidparent,
            menuidchild: row.itemidchild,
            voice: row.voice,
            mp4: 1,
            numbers: row.id
          }
          this.$router.push({
            name: 'videoplay',
            query: paramer
          })
        } else {
          let paramer = {
            menuidparent: row.menuidparent,
            menuidchild: row.menuidchild,
            voice: row.voice,
            mp4: row.mp4 === 1 ? 1 : 0,
            numbers: row.id
          }
          this.$router.push({
            name: 'videoplay',
            query: paramer
          })
        }
      },
      // 熱門影音内容，點擊某一條觸發事件
      hotRowClickLatestUpdates (row, column, event) {
        let paramer = {
          menuidparent: row.menuidparent,
          menuidchild: row.menuidchild,
          voice: row.voice,
          mp4: row.mp4,
          numbers: row.mediaid
        }
        this.$router.push({
          name: 'videoplay',
          query: paramer
        })
      },
      // 點擊目錄查詢出内容，點擊某一條觸發事件
      rowClick (row, column, event) {
        if (this.topspeechShow) {
          let paramer = {
            menuidparent: row.itemidparent,
            menuidchild: row.itemidchild,
            voice: row.voice,
            mp4: 1,
            numbers: row.mediaid
          }
          this.$router.push({
            name: 'videoplay',
            query: paramer
          })
        } else {
          let paramer = {
            menuidparent: row.menuidparent,
            menuidchild: row.menuidchild,
            voice: row.voice,
            mp4: row.mp4 === 1 ? 1 : 0,
            numbers: row.mediaid
          }
          this.$router.push({
            name: 'videoplay',
            query: paramer
          })
        }
        sessionStorage.setItem('pageNum', this.currentPage)
        sessionStorage.setItem('breadTitle', this.breadTitle)
      },
      // 輸入關鍵字查詢内容，點擊某一條觸發事件
      queryrowClick (row, column, event) {
        console.log(row)
        let paramer = {
          menuidparent: row.menuidparent,
          menuidchild: row.menuidchild,
          voice: row.voice,
          mp4: row.mp4 === 1 ? 1 : 0,
          numbers: row.mediaid
        }
        this.$router.push({
          name: 'videoplay',
          query: paramer
        })
        // 20231016 跳转之前把关键字存起来
        sessionStorage.setItem('querykeys', this.input)
        sessionStorage.setItem('pageNum', this.currentPageSearch)
        sessionStorage.setItem('topScrollTo', document.getElementById('searchInputId').getBoundingClientRect().top)
        if (this.input) {
          sessionStorage.setItem('searchInput', this.input)
        }
      },
      // 輸入關鍵字后，點擊查詢時觸發的事件
      queryList (e) {
        this.input = e
        this.clickQuery = true
        let paramm = []
        paramm.push(this.input)
        this.currentPageSearch = 1
        this.QUERY_BAOEN_ALL_LIST({paramer: paramm, page: 1, pagenum: 20, column: 'menuid', type: 'desc'})
      },
      _isMobile: function () {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        console.log(flag)
        if (flag) {
          // 手機
          return true
        } else {
          // 电脑版
          return false
        }
      },
      // 给子组件回调此方法，目的是  记录一下  页数currentPage   和  列表棋盘标志 selectRadio
      playcardClick: function () {
        sessionStorage.setItem('pageNum', this.currentPage)
        sessionStorage.setItem('breadTitle', this.breadTitle)
        sessionStorage.setItem('selectRadio', this.selectRadio)
      }
    },
    computed: {
      ...mapState(
        ['baoenTree', 'baoenloading', 'recentspeech', 'hotspeech', 'topspeech', 'ftpstatement', 'baoenQueryList', 'baoenQueryListSize', 'topspeechShow', 'queryloading', 'baoenCategoryList', 'preUrl']
      )
    },
    mounted () {
      this.INIT_BAOEN_TREE()
      let param = this.$route.query
      console.log('query對象%o', param)
      console.log('query對象categoryid%o', param.categoryid)
      // 20231016 此處代碼  主要是控制直接返回時  直接調用上次的參數查詢
      let querykeys = sessionStorage.getItem('querykeys')
      let pageNum = sessionStorage.getItem('pageNum')
      let breadTitle = sessionStorage.getItem('breadTitle')
      let topScrollTo = sessionStorage.getItem('topScrollTo')
      let selectRadio = sessionStorage.getItem('selectRadio')
      if (param.categoryid !== undefined) {
        let paramer = []
        paramer.push(param.categoryid)
        this.parentid = param.categoryid
        // 当前页存在 就直接赋值
        if (pageNum != null && pageNum !== undefined && pageNum !== '') {
          this.currentPage = Number(pageNum)
        } else {
          // 当前页为空时，直接赋值为 1
          pageNum = 1
        }
        this.GET_BAOEN_LIST({paramer: paramer, page: pageNum, pagenum: 20, column: 'menuid', type: 'desc'})
        sessionStorage.removeItem('pageNum')
        if (selectRadio != null && selectRadio !== undefined && selectRadio !== '') {
          this.selectRadio = selectRadio
          sessionStorage.removeItem('selectRadio')
        }
      } else {
        console.log('2')
      }
      if (breadTitle != null && breadTitle !== undefined && breadTitle !== '') {
        sessionStorage.removeItem('breadTitle')
        this.breadTitle = breadTitle
      }
      if (querykeys != null && querykeys !== undefined && querykeys !== '') {
        sessionStorage.removeItem('querykeys')
        sessionStorage.removeItem('pageNum')
        sessionStorage.removeItem('topScrollTo')
        this.input = querykeys
        this.currentPageSearch = Number(pageNum)
        this.clickQuery = true
        let paramm = []
        paramm.push(this.input)
        this.QUERY_BAOEN_ALL_LIST({paramer: paramm, page: pageNum, pagenum: 20, column: 'menuid', type: 'desc'})
        // 设置一下定位
        setTimeout(() => {
          window.scrollTo(0, topScrollTo)
        }, 1000)
      }
      let heightFlag = this._isMobile()
      // 移动
      if (heightFlag) {
        this.pageCount = 5
        this.layoutStyle = 'total, prev, pager, next'
      } else {
        this.pageCount = 19
        this.layoutStyle = 'total, prev, pager, next, jumper'
      }
      // 清空會話中的  輸入框保存的值
      sessionStorage.removeItem('searchInput')
    },
    destroyed () {
      this.DES_BAOEN_TREE()
    },
    components: {
      card,
      playcard,
      memoryrecent
    }
  }
</script>

<style scoped lang="scss">
  .left-content {
    padding-right: 16px;
    padding-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .item {
      background-color: #FFFFFF;
      padding: 10px 10px 10px 0px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      align-self: flex-start;
      position: relative;
      margin: 20px 10px 10px 0px;

      .title-box {
        width: 15px;
        height: 40px;
        background-color: #A6DCE7;
      }

      .content {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .up {
          font-size: 25px;
          font-weight: bold;
          letter-spacing: 2px;
          line-height: 32px;
          color: #6d6e71;
        }

        .down {
          color: #6d6e71;
          font-size: 12px;
          letter-spacing: 3px;
          font-family: Arial, Helvetica, SansSerif;
        }
      }
    }

    .tree {
      align-self: flex-start;
    }
  }

  .title-div {
    font-size: 17px;
    font-weight: bold;
    padding: 30px 30px 30px 30px;
    background-color: #ecf3f6;
  }

  .update-div {
    font-size: 17px;
    font-weight: bold;
    padding: 30px 30px 0px 30px;
    background-color: #FFFFFF;
  }

  .search-div {
    padding: 30px 30px 30px 30px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    span {
      margin-right: 20px;
      width: 50px;
    }
  }

  .right-table {
    padding: 0px 30px 50px 30px;
    .rowstyle{
      cursor: pointer;
    }
  }

  .topspeechList {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    background-color: #ecf3f6;
  }
.el-table /deep/ tr {
  cursor: pointer;
}
  .breadTitleColor /deep/ .el-breadcrumb__inner {
    color: black;
    font-weight: bold;
  }
  /deep/.el-tree .el-tree-node__content:hover {
    color: #409EFF; /* 您可以替换为您想要的颜色 */
  }
  /deep/.el-tree .el-tree-node__content.parent:has(is-current) {
    border-color: #409EFF; /* 您可以替换为您想要的颜色 */
    color: #409EFF; /* 修改文字颜色，确保文字可读性 */
  }

</style>



// WEBPACK FOOTER //
// lectureroom.vue?4947fe23